/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WarehouseRemarkVo
 */
export interface WarehouseRemarkVo {
    /**
     * 中国仓库备注
     * @type {string}
     * @memberof WarehouseRemarkVo
     */
    warehouseRemarkCn?: string;
    /**
     * 韩国仓库备注
     * @type {string}
     * @memberof WarehouseRemarkVo
     */
    warehouseRemarkKr?: string;
}

/**
 * Check if a given object implements the WarehouseRemarkVo interface.
 */
export function instanceOfWarehouseRemarkVo(value: object): value is WarehouseRemarkVo {
    return true;
}

export function WarehouseRemarkVoFromJSON(json: any): WarehouseRemarkVo {
    return WarehouseRemarkVoFromJSONTyped(json, false);
}

export function WarehouseRemarkVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WarehouseRemarkVo {
    if (json == null) {
        return json;
    }
    return {
        
        'warehouseRemarkCn': json['warehouseRemarkCn'] == null ? undefined : json['warehouseRemarkCn'],
        'warehouseRemarkKr': json['warehouseRemarkKr'] == null ? undefined : json['warehouseRemarkKr'],
    };
}

export function WarehouseRemarkVoToJSON(json: any): WarehouseRemarkVo {
    return WarehouseRemarkVoToJSONTyped(json, false);
}

export function WarehouseRemarkVoToJSONTyped(value?: WarehouseRemarkVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'warehouseRemarkCn': value['warehouseRemarkCn'],
        'warehouseRemarkKr': value['warehouseRemarkKr'],
    };
}

